// 全站 tag 標籤 元件
'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useSearchParams } from 'next/navigation';

const TagComponent = ({ location, tag, isDragging = true }) => {
    const pathname = usePathname(); // 當前路徑名稱
    const searchParams = useSearchParams();
    const currentParams = searchParams.get('type') || ''; // 取得 category2
    const currentTag = searchParams.get('tag') || ''; // 取得 tagId

    // 點擊 標題列 自定義 tag 切換
    const onClick = () => {
        if (!isDragging)
            window.history.replaceState(
                null,
                '',
                pathname +
                    (currentParams ? `?type=${currentParams}&tag=${tag?.id}` : `?tag=${tag?.id}`)
            );
    };

    // 內容列 自定義 tag
    if (location === 'list')
        return (
            <Link
                href={`/search/${tag}`}
                target="_blank"
                rel="noreferrer noopener"
                className="text-center rounded-[4px] text-btn1 text-black3 border-1 border-[rgba(176,176,176,.50)] px-[8px] py-[4px]
                 flex-shrink-0 trans hover:bg-bou hover:text-white hover:border-bou ulg:text-btn2"
            >
                {tag}
            </Link>
        );

    // 分類列表標題列 自定義 tag
    return (
        <button
            onClick={onClick}
            className={`text-center rounded-[4px] text-btn1 text-white border-1 border-white border-opacity-[.2] px-[20px] py-[4px]
            bg-jblack bg-opacity-[.2]
            ${
                Number(currentTag) === Number(tag?.id)
                    ? 'border-opacity-[.6] bg-white bg-opacity-[.2] backdrop-blur-[10px]'
                    : 'trans hover:border-opacity-[.6] hover:bg-white hover:bg-opacity-[.2] hover:backdrop-blur-[10px]'
            }`}
        >
            {tag?.tag}
        </button>
    );
};

export default TagComponent;
